exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".spanreg[data-v-056d9592]{padding:3px 10px 3px 3px;border-radius:6px}.is-select[data-v-056d9592]{background-color:#5a5a5a;color:#fff}.has-text-warning[data-v-056d9592]{color:#e6b800!important}.has-text-grey[data-v-056d9592]{color:#aeaeae!important}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-056d9592","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/facturar/componentsfra/Viewitems.vue
// module id = 735
// module chunks = 0